<template>
  <div>
    <v-flex v-if="terc.length === 6" xs12>
      <v-autocomplete
        :id="label"
        v-model="selectedSIMC"
        append-icon="undefined"
        outlined
        item-text="name"
        item-value="symbol"
        :disabled="true"
        :items="cities"
        :label="label"
      />
    </v-flex>
  </div>
</template>

<script>
import axios from 'axios';

import { notificationsMixin } from '@/mixins/notifications';

// @vuese
// Input na SIMC-a
// @group Forms
export default {
  mixins: [notificationsMixin],
  props: {
    // Schema
    model: {
      type: Object,
      required: true
    },
    // Nazwa pola z SIMC-em
    field: {
      type: String,
      required: false,
      default: 'simc'
    },
    // Wartość TERC-a
    terc: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      cities: [],
      selectedSIMC: undefined,
      label: this.model[this.field].$schema.fieldRequired ? 'Miejscowość *' : 'Miejscowość'
    };
  },
  watch: {
    terc(newValue) {
      if (newValue) {
        this.getSIMCList();
      } else {
        this.cleanSIMC();
      }
    }
  },
  beforeMount() {
    this.getSIMCList();
    this.setSIMCData();
  },
  methods: {
    // @vuese
    // Pobiera listę miejscowości
    getSIMCList() {
      if (this.terc.length === 6) {
        axios
          .get(`${process.env.VUE_APP_TERYT_API_URL}/simc/?terc=${this.terc}`)
          .then(res => {
            this.cities = res.data.list;
            if (this.cities.length === 1) {
              this.selectedSIMC = this.cities[0].symbol;
              this.changeCity(this.cities[0].symbol);
            }
          })
          .catch(() => this.notifyError('Nie udało się pobrać listy miejscowości'));
      } else {
        this.cleanSIMC();
      }
    },
    // @vuese
    // Wyczyszczenie formularza
    cleanSIMC() {
      this.cities = [];
      this.selectedSIMC = undefined;
      this.model.$setData({
        city: '',
        [this.field]: ''
      });
    },
    // @vuese
    // Ustawianie pól formularza
    setSIMCData() {
      this.selectedSIMC = this.model[this.field].$value;
    },
    // @vuese
    // Zapisanie w schema i wyczyszczenie odpowiednich pól po wybraniu miejscowości
    changeCity(val) {
      this.model.$setData({
        city: val ? this.cities.find(item => item.symbol === val).name : '',
        [this.field]: val ? val : ''
      });
    },
    // @vuese
    // Focus na polu
    focus(field) {
      this.model[field].$hasFocus = true;
    },
    // @vuese
    // Blur na polu
    blur(field) {
      this.model[field].$hasFocus = false;
    }
  }
};
</script>
